import styled from 'styled-components';

export const SubSection = styled.div`
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 991.92px) {
    flex-direction: column;
    
  }
`;

export const ViewEditField = styled.div`
  display:flex;  
  margin: 0 0 15px 0;
  @media only screen and (max-width: 991.92px) {
    margin: 0 0 5px 0;
  }
`;

export const ViewLabel = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.textColor};
  font-weight: normal;
  margin: 0px;
  margin-top: 15px;
  @media only screen and (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const CustomTableForPrint = styled.table`
  width: 100%;
  font-size: ${props => props.theme.fontSize.primary};
  thead tr { 
    border-bottom: solid 1px ${props => props.theme.border.tableBorder};
  }
  thead tr, tbody tr {
    width: 100%;
  }
  thead tr th {
    width: 50%;
    font-weight: normal;
  }
  thead tr th div{
    width: 100%;
    padding: 16px 10px;
    color: ${props => props.theme.fontColors.headingColor};        
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    line-height: ${props => props.theme.lineHeight.tableFont};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
  }
  tbody tr td, tbody tr td div {
    width: 50%;
    padding: 5px 10px;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    color: ${props => props.theme.fontColors.textColor};
    letter-spacing: ${props => props.theme.letterSpacing.point6};
    border-bottom: none;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
  }
`;